module.exports = __webpack_public_path__ + "img/2.ec996d45.png";